import React from 'react';

/* Real gap this closes (found live, 2026-09-02): the app had no React error boundary
   anywhere. A single render exception in any tab (for example while displaying a chat
   image) unmounted the entire React tree - not just that tab - leaving a blank white
   page with no way to recover except a manual browser refresh, and no record of what
   happened anywhere the team could see it. This component stops that: it only wraps
   <main> in App.jsx, so a crash inside one tab's content shows a recoverable message
   there while the header (language switch, sign out) stays usable, and it logs the
   real error/component stack to the browser console so it's not silently lost. */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] Caught a render error:', error, info?.componentStack);
  }

  handleRetry = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div className="error-boundary" role="alert">
          <p>משהו השתבש בהצגת המסך הזה. שום דבר לא נמחק - אפשר לנסות שוב או לרענן את הדף.</p>
          <div className="error-boundary-actions">
            <button type="button" className="btn" onClick={this.handleRetry}>נסה שוב</button>
            <button type="button" className="btn" onClick={() => window.location.reload()}>רענן את הדף</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
